"use client";

import { useQuery } from "@tanstack/react-query";

export type SessionRow = {
  id: string;
  deviceLabel: string;
  userAgent: string;
  ip: string;
  approxLocation: string | null;
  createdAt: string;
  lastActiveAt: string;
  isCurrent: boolean;
};

async function fetchSessions(): Promise<SessionRow[]> {
  const res = await fetch("/api/auth/sessions", { credentials: "include" });
  const json = (await res.json()) as {
    success: boolean;
    code?: string;
    error?: string;
    data?: { sessions: SessionRow[] };
  };
  if (!res.ok || !json.success) {
    throw new Error(json.error ?? "Could not load sessions");
  }
  return json.data?.sessions ?? [];
}

export const SESSIONS_QUERY_KEY = ["auth-sessions"] as const;

export function useSessionsQuery(initialSessions?: SessionRow[] | null) {
  return useQuery({
    queryKey: SESSIONS_QUERY_KEY,
    queryFn: fetchSessions,
    initialData: initialSessions ?? undefined,
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    refetchOnMount: initialSessions ? false : true,
    refetchOnWindowFocus: false,
  });
}
